export default __webpack_public_path__ + "static/media/60.9b78ebcb.png";